import { MUI } from "@amps/material-ui";

export default MUI.makeStyles(() => ({
  pageTitle: {
    display: "flex",
    marginTop: "16px",
    marginBottom: "32px"
  }
}));
